module.exports = __webpack_public_path__ + "img/intranet.fd2b499a.svg";